import React from 'react';
import { FilterBuilder } from './filters';
import { callFilterCategories } from '@/config/callFilterMeta';
import { getCallPresetCategories } from '@/config/callPresets';
import { FilterRecord } from '@/types/filterBuilder';
import { CallFilterResult } from '@/types/callFilters';

interface CallFilterBuilderProps {
  onApplyFilters: (filters: CallFilterResult) => void;
  activeFilters?: CallFilterResult | null;
  onClearFilters?: () => void;
}

export function CallFilterBuilder({
  onApplyFilters,
  activeFilters,
  onClearFilters,
}: CallFilterBuilderProps) {
  const handleApplyFilters = (filters: FilterRecord) => {
    // Convert number-like strings to proper types
    const processed: CallFilterResult = {};
    for (const [key, value] of Object.entries(filters)) {
      if (value === null || value === undefined || value === '') continue;
      if (key === 'days_ago') {
        (processed as any)[key] = Number(value);
      } else if (['was_successful', 'had_voicemail', 'scheduled_today', 'scheduled_tomorrow', 'scheduled_this_week', 'has_scheduled_calls'].includes(key)) {
        (processed as any)[key] = value === true || value === 'true';
      } else {
        (processed as any)[key] = value;
      }
    }
    onApplyFilters(processed);
  };

  return (
    <FilterBuilder
      categories={callFilterCategories}
      presetCategories={getCallPresetCategories()}
      entityName="Calls"
      onApplyFilters={handleApplyFilters}
      activeFilters={activeFilters}
      onClearFilters={onClearFilters}
    />
  );
}

export default CallFilterBuilder;
